import React from 'react';
import "./Messages.scss";

const Messages = ({ date, message, direction }) => {
  return <div className="message" style={ {
    background: direction === 1 ? "#F7F7F7" : "#246BFD",
  } }>
    <p className={ "text" } style={ {
      color: direction === 1 ? "grey" : "white"
    } }>{message} </p>
    <p style={ {
      color: direction === 1 ? "grey" : "white"
    } } className={ "date" }>{new Date(date).toLocaleDateString()}</p>
  </div>
}

export default Messages